"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const node_polyglot_1 = __importDefault(require("node-polyglot"));
const Request = __importStar(require("../request"));
const Language = __importStar(require("../language"));
const Credentials = __importStar(require("../credentials"));
const CMS = __importStar(require("../cms"));
class I18n {
    constructor(withBackend, urlFetch) {
        this.wasInit = false;
        this.lang = this.getLang();
        this.urlFetch = urlFetch ? urlFetch : this.getUrlFetch();
        this.withBackend = withBackend;
        this.init();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.withBackend) {
                return Request.get(this.urlFetch)
                    .then(res => {
                    const polyglot = new node_polyglot_1.default({ phrases: res });
                    this.translator = polyglot.t.bind(polyglot);
                })
                    .finally(() => {
                    this.wasInit = true;
                });
            }
        });
    }
    setLanguage(language) {
        this.lang = language;
    }
    translate(key, replaceVars) {
        if (!this.translator) {
            return key;
        }
        const content = this.translator(key);
        return CMS.substituteVars(content, replaceVars, '%{');
    }
    getUrlFetch() {
        if (process.env.I18N_URL_FETCH) {
            return process.env.I18N_URL_FETCH.replace('${locale}', this.lang);
        }
        return `/product/i18n/serve${this.queryString()}`;
    }
    getLang() {
        try {
            return Credentials.getLanguage();
        }
        catch (err) {
            return Language.languageDefault;
        }
    }
    queryString(lang) {
        return `?locale=${lang ? lang : this.lang}`;
    }
}
exports.default = I18n;
